import { v4 as uuidv4 } from 'uuid';

/** Функция для получения уникального UUID */
export function getUUID() {
  return uuidv4();
}
